// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__6vUQ8","header":"Messages_header__1owuy"};